/* pdp-jumpbar.js
   WHAT: Builds a horizontal strip of in-page jump links under the buybox on every PDP.
   WHY:  Owner 2026-10-06 - "it is worth have tags on the page that jump to e.g. x5i top
         shows add to cart section, reviews, story, specs, faq. i am just trying to find a
         way to make navigation faster." PDPs run long now that reviews sit at position 2,
         so the specs and FAQ are a lot of scrolling away.
   WHEN: 2026-10-06.

   Built from the DOM rather than the template, so all 30 PDPs get it without 30 Customizer
   -owned template writes, and a page that lacks a section simply has no chip for it. */
(function () {
  'use strict';

  // Two pdp-accordion sections render on most PDPs - specs and FAQ - so the type alone
  // cannot label them. Their own heading does.
  var LABELS = {
    'pdp-reviews': 'Reviews',
    'pdp-intro': null,
    // Owner 2026-10-09: "rather than story on the pdp should we call this features?" - yes.
    // The section's cards ARE features ("Built on parts you can replace", "USB-C audio"); it is
    // only the FRAMING that is story. A jump chip has to say what is in the section, and
    // "Story" is internal brand language that tells a shopper nothing.
    'pdp-story': 'Features',
    'pdp-video': 'Video',
  };

  // Owner 2026-10-09: "clicking Top on any page's jumplinks should go to the very top of the
  // page so the full nav menu shows." It used to anchor to the buybox, which sits BELOW the
  // header, so it landed under the nav instead of above it. Shared with the support page.
  function topHandler(ev) {
    ev.preventDefault();
    // Instant, not smooth. Owner 2026-10-09: "top needs to land at the top. that is the
    // whole point." A smooth scroll animates for over a second, and during it the pinned bar
    // unpins and the header comes back, so the page is visibly in motion and can look like it
    // stopped short. Jumping straight to 0 lands where the brief says, every time.
    // `behavior: 'instant'` explicitly, because this stylesheet sets
    // `html { scroll-behavior: smooth }` for the other chips - and that CSS overrides a plain
    // scrollTo(0,0), animating it for over a second. That is what made Top look like it
    // stopped short of the top.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    var hdr = document.querySelector('.ba-site-header');
    if (hdr) {
      hdr.setAttribute('tabindex', '-1');
      hdr.focus({ preventScroll: true });
    }
  }

  function headingOf(el) {
    var h = el.querySelector('h2, .ba-pdp-acc__title, [class*="__eyebrow"]');
    return h ? h.textContent.trim().replace(/[.\u2026]+$/, '') : '';
  }


  // Shared by the PDP bar (built above) and the support page's server-rendered bar.
  // The site header is `position: relative`, so it scrolls away rather than staying put.
  // Using its HEIGHT would keep pushing the bar down by a header that is no longer on
  // screen; its BOTTOM edge is the right number - equal to the height while the header is
  // fully visible, shrinking as it leaves, 0 once gone - so the bar slides up and ends
  // flush with the top of the viewport. Clamped to the height so a sticky header would
  // also work. Not `position: sticky` because that offset has to be measured.
  function attachPin(bar, sentinel, spacer) {
    function headerOffset() {
      var h = document.querySelector('.ba-site-header');
      if (!h) return 0;
      var r = h.getBoundingClientRect();
      return Math.max(0, Math.min(Math.round(r.bottom), Math.round(r.height)));
    }
    var pinned = false;
    function sync() {
      var top = headerOffset();
      // Strict `<`: at rest the sentinel sits exactly at the header's bottom edge, and
      // `<=` would pin on load, inserting the spacer and shifting the page for nothing.
      var should = sentinel.getBoundingClientRect().top < top;
      if (should !== pinned) {
        pinned = should;
        bar.classList.toggle('is-pinned', pinned);
        spacer.style.height = pinned ? bar.offsetHeight + 'px' : '0px';
      }
      bar.style.top = pinned ? top + 'px' : '';
    }
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
  }

  // The support page ships its bar in the HTML (see sections/ba-support-product.liquid),
  // because its topics come from a metaobject rather than from sections on the page. Here
  // the script only has to pin it, so it wraps it with the same sentinel/spacer pair and
  // returns before any of the PDP-building logic runs.
  function adoptPrerendered() {
    var bar = document.querySelector('.ba-pdp-jump[data-jump-prerendered]');
    if (!bar || bar.dataset.jumpPinned) return false;
    bar.dataset.jumpPinned = '1';
    // The support bar is rendered in Liquid, so its Top chip gets the handler here.
    var topChip = bar.querySelector('[data-jump="top"] .ba-pdp-jump__chip');
    if (topChip) topChip.addEventListener('click', topHandler);
    var sentinel = document.createElement('div');
    sentinel.className = 'ba-pdp-jump__sentinel';
    var spacer = document.createElement('div');
    spacer.className = 'ba-pdp-jump__spacer';
    bar.insertAdjacentElement('beforebegin', spacer);
    spacer.insertAdjacentElement('beforebegin', sentinel);
    attachPin(bar, sentinel, spacer);
    return true;
  }

  function build() {
    if (adoptPrerendered()) return;

    var buybox = document.querySelector('[data-section-type="pdp-buybox"]');
    if (!buybox || document.querySelector('.ba-pdp-jump')) return;

    var items = [{ label: 'Top', target: buybox, key: 'top' }];
    var sections = document.querySelectorAll('[data-section-type^="pdp-"]');

    for (var i = 0; i < sections.length; i++) {
      var el = sections[i];
      var type = el.getAttribute('data-section-type');
      if (type === 'pdp-buybox' || type === 'pdp-banner' || type === 'pdp-closer' ||
          type === 'pdp-anton-concierge' || type === 'pdp-related') continue;

      var label = null;
      var key = type.replace('pdp-', '');
      if (type === 'pdp-accordion') {
        var h = headingOf(el);
        // Anything that is not the FAQ accordion is the spec table. Both render as
        // `pdp-accordion`, so the KEY has to come from the label too - otherwise they
        // share one key and a rule meant for FAQ would hide the spec chip as well.
        if (/faq|question/i.test(h)) { label = 'FAQ'; key = 'faq'; }
        else { label = 'Specs'; key = 'specs'; }
      } else if (Object.prototype.hasOwnProperty.call(LABELS, type)) {
        label = LABELS[type];
      }
      if (!label) continue;
      if (!el.id) el.id = 'jump-' + type.replace('pdp-', '') + '-' + i;
      items.push({ label: label, target: el, key: key });
    }

    // Owner 2026-10-06: "rather than related, the last link in the jumplinks should be Help,
    // which takes them to the product support page."
    //
    // The href is READ OFF the page rather than built from the handle. Per-product support
    // pages exist for some products and not others, so `/pages/support-<handle>` would 404
    // wherever one has not been made. The PDP already links to its own support page when it
    // has one, so that link is the only trustworthy source - and the site-wide /pages/support
    // is the fallback when it does not.
    var supportHref = '';
    var links = document.querySelectorAll('a[href*="/pages/support"]');
    for (var n = 0; n < links.length; n++) {
      var href = links[n].getAttribute('href') || '';
      if (/\/pages\/support-[a-z0-9-]+/i.test(href)) { supportHref = href; break; }
      if (!supportHref && /\/pages\/support\/?$/i.test(href)) supportHref = href;
    }
    if (supportHref) items.push({ label: 'Help', href: supportHref, key: 'help' });

    if (items.length < 3) return;   // not worth a bar for one or two stops

    var nav = document.createElement('nav');
    nav.className = 'ba-pdp-jump';
    nav.setAttribute('aria-label', 'Jump to a section of this page');
    var ul = document.createElement('ul');
    ul.className = 'ba-pdp-jump__list';

    items.forEach(function (it) {
      var li = document.createElement('li');
      // The chip's own key is carried on the element so CSS can act on a specific
      // destination - mobile hides FAQ this way. Matching on the visible text would
      // break the moment a label is reworded.
      li.setAttribute('data-jump', it.key || '');

      // Owner 2026-10-09: "do not call it buy - i do not want to see the word buy added to
      // the url at all. top was what i said it should be called."
      //
      // The LABEL was renamed to Top earlier, but the anchor still pointed at the buybox's
      // `id="buy"`, so "#buy" is what landed in the address bar - the rename was cosmetic.
      // Top is a <button> now: it scrolls, it writes nothing to the URL, and the word cannot
      // appear. There is also no `jump-buy` fallback id any more.
      //
      // Everything else stays a real <a href="#...">, which is what an in-page link should
      // be - native anchor navigation moves FOCUS as well as scroll position, which keyboard
      // and screen-reader users depend on.
      var a = document.createElement(it.key === 'top' ? 'button' : 'a');
      a.className = 'ba-pdp-jump__chip';
      if (it.key === 'top') {
        a.type = 'button';
        a.addEventListener('click', topHandler);
      } else {
        if (it.target && !it.target.id) {
          it.target.id = 'jump-' + (it.key || 'section');
        }
        a.href = it.href ? it.href : '#' + it.target.id;
      }
      a.textContent = it.label;
      li.appendChild(a);
      ul.appendChild(li);
    });

    nav.appendChild(ul);

    var bar = document.createElement('div');
    bar.className = 'ba-pdp-jump';
    var sentinel = document.createElement('div');
    sentinel.className = 'ba-pdp-jump__sentinel';
    var spacer = document.createElement('div');
    spacer.className = 'ba-pdp-jump__spacer';

    // Owner 2026-10-06, final shape after three passes: "i think it should just lock onto
    // the nav menu and hang", "breadcrumbs can disappear", and then "no, the jumplinks the
    // nav, as they are page nav."
    //
    // So the bar belongs WITH the site nav, not under the breadcrumbs: it is inserted
    // immediately after the header and hangs off it. The breadcrumbs are not touched at
    // all - they stay in the buybox and scroll away as normal.
    //
    // Not `position: sticky`: the header's own height changes (announcement bar, mobile vs
    // desktop) so the offset has to be measured, and the bar is pinned manually once its
    // sentinel reaches the bottom of the header. A spacer holds its height while pinned so
    // the page does not jump.
    var header = document.querySelector('.ba-site-header');
    var anchor = header || document.querySelector('.ba-pdp-buybox__crumbs');
    if (!anchor) { buybox.insertAdjacentElement('afterend', nav); return; }

    anchor.insertAdjacentElement('afterend', sentinel);
    sentinel.insertAdjacentElement('afterend', spacer);
    spacer.insertAdjacentElement('afterend', bar);
    bar.appendChild(nav);
    nav.className = 'ba-pdp-jump__nav';

    // The site header is `position: relative`, so it scrolls away rather than staying put.
    // Using its height would therefore keep pushing the bar down by a header that is no
    // longer on screen. Its BOTTOM edge is the right number: it equals the header height
    // while the header is fully visible, shrinks as the header scrolls off, and reaches 0
    // once it has gone - so the bar slides up and ends flush with the top of the viewport.
    // Clamped to the header height so a sticky header (if that ever changes) also works.
    attachPin(bar, sentinel, spacer);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
